"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var material_kit_pro_react_1 = require("../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b;
    return (0, styles_1.makeStyles)({
        container: material_kit_pro_react_1.container,
        content: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center'
        },
        remember: {
            alignItems: 'flex-start',
            flexGrow: 1
        },
        forgotContainer: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            margin: theme.spacing(3.5, 0, 3)
        },
        forgot: {
            display: 'flex',
            alignItems: 'flex-end'
        },
        register: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        primaryText: {
            color: colorsV2_1.default.palette.primaryP500.hex(),
            fontSize: '16px'
        },
        buttonText: {
            color: (_a = colorsV2_1.default.commonColors.white) === null || _a === void 0 ? void 0 : _a.hex()
        },
        alert: {
            background: (_b = colorsV2_1.default.commonColors.backgroundWeb) === null || _b === void 0 ? void 0 : _b.hex(),
            color: colorsV2_1.default.palette.neutralsN700.hex(),
            margin: theme.spacing(0, 0, 0, -1)
        },
        alertIcon: {
            marginRight: theme.spacing(1),
            color: colorsV2_1.default.palette.neutralsN900.hex(),
            height: '20px'
        },
        alertBase: {
            display: 'flex',
            margin: theme.spacing(0.5, 0, 1)
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map